
import {auth} from '@/firebase.js';

export default {
  state:{
    token:null,
    intentos:0
  },
  mutations: {
    setUsuario(state,token){
      state.token=token;
    }
  },
  actions: {
    async ActualizarUsuario(context,forceRefresh){
      var user = auth.currentUser;
      if (user!=null) {
        try {
          let idToken = await auth.currentUser.getIdToken(forceRefresh);

          context.commit('setUsuario',idToken);
        } catch (e) {

          auth.signOut();
          context.commit('setUsuario',null);
        }

      }else{
        context.commit('setUsuario',null);
      }
      return true;
    },
    logout(context){
      context.commit('setUsuario',null);
    }
  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/modules/usuario.js